module.exports = __webpack_public_path__ + "assets/img/my-item-03.ac159461.png";